/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

function mWPEcomCreateQuotationQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function mWPEcomCreateQuotationInput(
    createQuotationHeaderEntity: DataServiceEntities.IMWPCreateQuotHeaderEntity
): IDataServiceRequest {
    const query = mWPEcomCreateQuotationQuery();
    return query.createDataServiceRequestForOperation(
        'MWPEcomCreateQuotation',
        true,
        DataServiceEntities.MWPEcomCreateQuotResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMWPEcomCreateQuotResponse' },
        {
            createQuotationHeaderEntity: createQuotationHeaderEntity
        }
    );
}

export function mWPEcomCreateQuotationAsync(
    context: IContext,
    createQuotationHeaderEntity: DataServiceEntities.IMWPCreateQuotHeaderEntity
): AsyncResult<DataServiceEntities.IMWPEcomCreateQuotResponse> {
    const request = mWPEcomCreateQuotationInput(createQuotationHeaderEntity);
    return callActionOrExecute<DataServiceEntities.IMWPEcomCreateQuotResponse>(request, context.callerContext);
}

function mWPCreateSalesOrderFromQuotationQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function mWPCreateSalesOrderFromQuotationInput(quotationId: string): IDataServiceRequest {
    const query = mWPCreateSalesOrderFromQuotationQuery();
    return query.createDataServiceRequestForOperation(
        'MWPCreateSalesOrderFromQuotation',
        true,
        DataServiceEntities.CreateSalesOrderFromQuotResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICreateSalesOrderFromQuotResponse' },
        {
            quotationId: quotationId
        }
    );
}

export function mWPCreateSalesOrderFromQuotationAsync(
    context: IContext,
    quotationId: string
): AsyncResult<DataServiceEntities.ICreateSalesOrderFromQuotResponse> {
    const request = mWPCreateSalesOrderFromQuotationInput(quotationId);
    return callActionOrExecute<DataServiceEntities.ICreateSalesOrderFromQuotResponse>(request, context.callerContext);
}

function mWPGetQuotationsByCustomerIdQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function mWPGetQuotationsByCustomerIdInput(queryResultSettings: IQueryResultSettings, customerId: string): IDataServiceRequest {
    const query = mWPGetQuotationsByCustomerIdQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'MWPGetQuotationsByCustomerId',
        true,
        DataServiceEntities.MWPQuotationsByCustIdEntityExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMWPQuotationsByCustIdEntity' },
        {
            customerId: customerId
        }
    );
}

export function mWPGetQuotationsByCustomerIdAsync(
    context: IContext,
    customerId: string
): AsyncResult<DataServiceEntities.IMWPQuotationsByCustIdEntity[]> {
    const request = mWPGetQuotationsByCustomerIdInput(context.queryResultSettings || {}, customerId);
    return callActionOrExecute<DataServiceEntities.IMWPQuotationsByCustIdEntity[]>(request, context.callerContext);
}

function mWPGetQuotationsByQuotationIdQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function mWPGetQuotationsByQuotationIdInput(quotationId: string): IDataServiceRequest {
    const query = mWPGetQuotationsByQuotationIdQuery();
    return query.createDataServiceRequestForOperation(
        'MWPGetQuotationsByQuotationId',
        true,
        DataServiceEntities.MWPQuotationsByQuotIdEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMWPQuotationsByQuotIdEntity' },
        {
            quotationId: quotationId
        }
    );
}

export function mWPGetQuotationsByQuotationIdAsync(
    context: IContext,
    quotationId: string
): AsyncResult<DataServiceEntities.IMWPQuotationsByQuotIdEntity> {
    const request = mWPGetQuotationsByQuotationIdInput(quotationId);
    return callActionOrExecute<DataServiceEntities.IMWPQuotationsByQuotIdEntity>(request, context.callerContext);
}

function mWPCreateQuotationMoogQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function mWPCreateQuotationMoogInput(
    cartId: string,
    receiptEmail: string,
    receiptNumberSequence: string,
    cartVersion: number
): IDataServiceRequest {
    const query = mWPCreateQuotationMoogQuery();
    return query.createDataServiceRequestForOperation(
        'MWPCreateQuotationMoog',
        true,
        DataServiceEntities.MWPCreateQuotationResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMWPCreateQuotationResponse' },
        {
            cartId: cartId,
            receiptEmail: receiptEmail,
            receiptNumberSequence: receiptNumberSequence,
            cartVersion: cartVersion
        }
    );
}

export function mWPCreateQuotationMoogAsync(
    context: IContext,
    cartId: string,
    receiptEmail: string,
    receiptNumberSequence: string,
    cartVersion: number
): AsyncResult<DataServiceEntities.IMWPCreateQuotationResponse> {
    const request = mWPCreateQuotationMoogInput(cartId, receiptEmail, receiptNumberSequence, cartVersion);
    return callActionOrExecute<DataServiceEntities.IMWPCreateQuotationResponse>(request, context.callerContext);
}

function mWPCreateQuotationMoogNewQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function mWPCreateQuotationMoogNewInput(
    eCommerceRequestBodyEntity: DataServiceEntities.IMWPECommerceRequestBodyEntity
): IDataServiceRequest {
    const query = mWPCreateQuotationMoogNewQuery();
    return query.createDataServiceRequestForOperation(
        'MWPCreateQuotationMoogNew',
        true,
        DataServiceEntities.MWPEComQuotResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMWPEComQuotResponse' },
        {
            eCommerceRequestBodyEntity: eCommerceRequestBodyEntity
        }
    );
}

export function mWPCreateQuotationMoogNewAsync(
    context: IContext,
    eCommerceRequestBodyEntity: DataServiceEntities.IMWPECommerceRequestBodyEntity
): AsyncResult<DataServiceEntities.IMWPEComQuotResponse> {
    const request = mWPCreateQuotationMoogNewInput(eCommerceRequestBodyEntity);
    return callActionOrExecute<DataServiceEntities.IMWPEComQuotResponse>(request, context.callerContext);
}

function mWPIsAliveHQQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function mWPIsAliveHQInput(): IDataServiceRequest {
    const query = mWPIsAliveHQQuery();
    return query.createDataServiceRequestForOperation(
        'MWPIsAliveHQ',
        false,
        DataServiceEntities.MWPCheckHQAliveResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMWPCheckHQAliveResponse' },
        {}
    );
}

export function mWPIsAliveHQAsync(context: IContext): AsyncResult<DataServiceEntities.IMWPCheckHQAliveResponse> {
    const request = mWPIsAliveHQInput();
    return callActionOrExecute<DataServiceEntities.IMWPCheckHQAliveResponse>(request, context.callerContext);
}

function mWPProcessRestrictedProductsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function mWPProcessRestrictedProductsInput(
    mWPRestrictedProducts: DataServiceEntities.IMWPRestrictedProductsEntity
): IDataServiceRequest {
    const query = mWPProcessRestrictedProductsQuery();
    return query.createDataServiceRequestForOperation(
        'MWPProcessRestrictedProducts',
        true,
        DataServiceEntities.MWPEcomCreateQuotResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMWPEcomCreateQuotResponse' },
        {
            mWPRestrictedProducts: mWPRestrictedProducts
        }
    );
}

export function mWPProcessRestrictedProductsAsync(
    context: IContext,
    mWPRestrictedProducts: DataServiceEntities.IMWPRestrictedProductsEntity
): AsyncResult<DataServiceEntities.IMWPEcomCreateQuotResponse> {
    const request = mWPProcessRestrictedProductsInput(mWPRestrictedProducts);
    return callActionOrExecute<DataServiceEntities.IMWPEcomCreateQuotResponse>(request, context.callerContext);
}
